import { useLocation } from "react-router-dom";

// 「診断フローにホーム画面から入った」ことを表す履歴エントリの state。
// ホームから診断フローへ遷移する側が history.push(path, { fromHome: true }) で付与し、
// フロー内の遷移（イントロ→フォーム→結果）でも同じ state を引き継ぐ。
// グローバルなフラグと違い履歴エントリごとに値が付くため、クリア処理や再訪時の自己回復が不要で、
// back/forward でも常にそのエントリの入口が正しく判定される。
// アプリ再起動・直リンク・登録導線の強制遷移では state が無い＝登録導線と同じ表示に倒れる（安全側）。
export interface DiagnosisEntryState {
  fromHome?: boolean;
}

// true ならホーム起点。ステップチップスを出さず、登録導線のファネルイベントを送らず、
// 結果画面の出口をホームにする。
export const useFromHomeEntry = (): boolean => {
  const location = useLocation<DiagnosisEntryState | undefined>();
  return !!location.state?.fromHome;
};
